import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

// AddRouteFab — floating action button anchor used on narrow viewports
// (`< sm`) where the inline "+ 添加" text-link in the editor row is hidden.
// Mirrors the inline link's target + aria-label so a11y / routing stay
// identical; see wiki/decisions/06-design-system.md §Discover toolbar.

export function AddRouteFab() {
  const { t } = useTranslation('common')
  const label = t('newRouteLong')
  return (
    <Link
      to="/routes/new"
      data-testid="discover-add-fab"
      aria-label={label}
      title={label}
      className="fixed bottom-[calc(env(safe-area-inset-bottom)+1rem)] right-4 z-30 inline-flex h-12 w-12 items-center justify-center rounded-full bg-[var(--xr-brand-primary)] text-[var(--xr-brand-primary-ink)] shadow-[var(--xr-shadow-md)] hover:bg-[var(--xr-brand-primary-hover)] sm:hidden"
    >
      <svg
        viewBox="0 0 24 24"
        width={22}
        height={22}
        fill="none"
        stroke="currentColor"
        strokeWidth={2.4}
        strokeLinecap="round"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M12 5v14M5 12h14" />
      </svg>
    </Link>
  )
}
